import React from 'react';
import AnimationTv from '../images/tv.png';

function Alert(){
    alert('Redirecting..');
    window.open("home", "_self");
}
function Header() {
    return (
        <div className='content1-heading' id='content1-box'>
            <h1>Enjoy on your <span>TV</span>.</h1>
            <p className='content-details'>Watch on smart TVs, PlayStation, Xbox, Chromecast, Apple TV, Blu-ray players and more.</p>
            <div class="header-btns">
                <a href="#" target="_top">
                <button onClick={Alert} className='header-btn'>MORE&nbsp;&#9657;</button></a>
            </div>
            <div className='animation'>
            <img className='animation-img' src={AnimationTv}/>
            </div>
        </div>
    );
}

export default Header;
